class BannerList extends HTMLElement {
  constructor() {
    super();

    this.currentSlideIndex = 0;
    this.previousArrow = this.querySelector("[data-previous]");
    this.nextArrow = this.querySelector("[data-next]");
    this.bannerContainer = this.querySelector("[data-banner-container]");
    this.slides = this.bannerContainer.querySelectorAll("[data-banner]");
    
    if(!this.previousArrow || !this.nextArrow) return;
    
    this.previousArrow.addEventListener("click", () => { this.previousSlide(); });
    this.nextArrow.addEventListener("click", () => { this.nextSlide(); });
  }
  
  hasNextSlide() {
    return this.currentSlideIndex < this.slides.length - 1;
  }
  
  hasPreviousSlide() {
    return this.currentSlideIndex > 0;
  }

  nextSlide() {  
    this.previousArrow.classList.remove("hidden");
    this.nextArrow.classList.remove("hidden");
    this.currentSlideIndex++;
    this.bannerContainer.style.translate = "-" + this.currentSlideIndex + "00vw";
    if(!this.hasNextSlide()) {
      this.nextArrow.classList.add("hidden");
      return;
    }
  }

  previousSlide() {  
    this.previousArrow.classList.remove("hidden");
    this.nextArrow.classList.remove("hidden");
    this.currentSlideIndex--;
    this.bannerContainer.style.translate = "-" + this.currentSlideIndex + "00vw";
    if(!this.hasPreviousSlide()) {
      this.previousArrow.classList.add("hidden");
      return;
    }
  }
}

customElements.define("banner-list", BannerList);
